import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PIPELINE_STEP_SHAPES} from 'pipelines/GeneratedPipelineStepShapes';
import {DraftStepInputParents, StepInputParents} from 'pipelines/network/PipelineDAO';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import {JSONValue} from 'util/Types';

export interface StepInputParentsConfigurationProps {
  analysis: PipelineGraphQL;
  config: Record<string, JSONValue>;
  /**
   * Either the parent step of the step that is being created, or the step that is being configured.
   * Used to filter potential input steps so that steps downstream of `referenceStep` cannot be set
   * as input to the step that is being configured.
   * */
  referenceStep: GetAnalysisPipelineStep;
  setConfig: (newConfig: Record<string, JSONValue>) => void;
  setStepInputParents: (newStepInputParents: DraftStepInputParents) => void;
  stepInputParents: DraftStepInputParents;
}

export function isStepInputParentsComplete<StepType extends PipelineStepType, StepVersion extends number>(
  draftStepInputParents: DraftStepInputParents,
  stepType: StepType,
  stepVersion: StepVersion
): draftStepInputParents is StepInputParents<StepType, StepVersion> {
  const stepShape = PIPELINE_STEP_SHAPES[stepType][stepVersion];
  const expectedKeys = new Set(Object.keys(stepShape.inputDataShapes));
  const draftKeys = new Set(Object.keys(draftStepInputParents));

  return expectedKeys.size === draftKeys.size && [...expectedKeys].every((key) => draftKeys.has(key));
}
